module.exports = __webpack_public_path__ + "static/media/broken-connection.d403693c.svg";